// extracted by mini-css-extract-plugin
export var actionButton = "_ln-0";
export var actionMenuContainer = "_ln-i";
export var bubble = "_ln-2";
export var bubbleActionMenu = "_ln-j";
export var bubbleContext = "_ln-6";
export var bubbleItems = "_ln-7";
export var customer = "_ln-3";
export var divider = "_ln-8";
export var fileList = "_ln-9";
export var hiddenComment = "_ln-o";
export var infoAbove = "_ln-a";
export var internal = "_ln-4";
export var lightActionButton = "_ln-1";
export var link = "_ln-b";
export var merchant = "_ln-5";
export var message = "_ln-c";
export var profilePicture = "_ln-e";
export var quillToolbarContainer = "_ln-f";
export var senderDate = "_ln-g";
export var senderDateCustomer = "_ln-h";
export var senderName = "_ln-d";
export var time = "_ln-k";
export var uploadedImage = "_ln-l";
export var username = "_ln-m";
export var xsmall = "_ln-n";